/*
 * OMI Wheels - vehicle fitment data + matching rules.
 * Shared by the homepage finder and the product-page fitment box.
 *
 * Row: make, model, years, PCD, hub bore, offset min/max, wheel diameter
 * min/max, max width, minimum load per wheel (kg), bolt thread, and the
 * wheel "families" the wheel is badged for (used for warnings only).
 *
 * Any wheel is shown for any car when the specs fit. Bolt pattern must
 * match exactly and the bore must physically go on the hub; offset, size
 * and load do the rest. Brand wheels get looser tolerances because they
 * are bought for aggressive fitment on purpose.
 *
 * NOTE: offsets, sizes and load figures are typical factory ranges and
 * should be checked against supplier data before being relied on.
 */
(function (root) {
  'use strict';
  var VAG=['Audi','Volkswagen','VW','Skoda','SEAT','Cupra'],MERC=['Mercedes'],FORD=['Ford'],
      JLR=['Jaguar','Range Rover','Land Rover'],BMW=['BMW','Mini'],
      PSA=['Peugeot','Citroen','Vauxhall','Opel','DS'],TOY=['Toyota','Lexus'],
      HYU=['Hyundai','Kia'],REN=['Renault','Dacia','Nissan'];

  var ROWS = [
['Audi','A1 (GB)','2018-on','5x100',57.1,35,48,15,18,7.5,500,'M14x1.5',VAG],
['Audi','A3 / S3 / RS3','2003-on','5x112',57.1,35,50,16,20,8.5,560,'M14x1.5',VAG],
['Audi','TT (8J / 8S)','2006-2023','5x112',57.1,35,50,17,20,9,525,'M14x1.5',VAG],
['Audi','Q2','2016-on','5x112',57.1,35,48,17,20,8.5,600,'M14x1.5',VAG],
['Audi','Q3 (8U / F3)','2011-on','5x112',57.1,35,45,17,21,8.5,650,'M14x1.5',VAG],
['Audi','A4 / A5 / S4 / S5','2008-on','5x112',66.5,30,45,17,20,9,650,'M14x1.5',VAG],
['Audi','A6 / A7','2011-on','5x112',66.5,25,45,17,21,9.5,690,'M14x1.5',VAG],
['Audi','A8','2010-on','5x112',66.5,20,45,18,21,9.5,750,'M14x1.5',VAG],
['Audi','Q5 / SQ5','2008-on','5x112',66.5,25,40,18,22,9.5,700,'M14x1.5',VAG],
['Audi','Q7 / Q8','2015-on','5x112',66.5,18,35,19,23,10.5,850,'M14x1.5',VAG],
['Audi','e-tron / Q8 e-tron','2019-on','5x112',66.5,18,40,19,22,10,900,'M14x1.5',VAG],
['Volkswagen','Polo','2009-on','5x100',57.1,35,48,15,18,7.5,500,'M14x1.5',VAG],
['Volkswagen','Golf Mk5 / Mk6','2003-2012','5x112',57.1,38,50,15,19,8.5,525,'M14x1.5',VAG],
['Volkswagen','Golf Mk7 / Mk8 / R','2012-on','5x112',57.1,38,50,16,20,8.5,560,'M14x1.5',VAG],
['Volkswagen','Scirocco','2008-2017','5x112',57.1,38,50,17,19,8.5,525,'M14x1.5',VAG],
['Volkswagen','Passat / Arteon','2014-on','5x112',57.1,35,48,16,20,8.5,650,'M14x1.5',VAG],
['Volkswagen','Tiguan / T-Roc','2016-on','5x112',57.1,30,45,17,21,9,700,'M14x1.5',VAG],
['Volkswagen','Touareg','2010-on','5x112',66.5,20,40,18,22,10,900,'M14x1.5',VAG],
['Volkswagen','Caddy','2010-on','5x112',57.1,35,50,16,19,8,700,'M14x1.5',VAG],
['Volkswagen','Transporter T5 / T6','2003-on','5x120',65.1,40,55,16,20,8.5,900,'M14x1.5',['Volkswagen','VW','Transporter']],
['Skoda','Fabia','2014-on','5x100',57.1,35,48,15,18,7.5,500,'M14x1.5',VAG],
['Skoda','Octavia / vRS','2013-on','5x112',57.1,38,50,16,20,8.5,580,'M14x1.5',VAG],
['Skoda','Superb','2015-on','5x112',57.1,35,48,17,20,8.5,650,'M14x1.5',VAG],
['Skoda','Kodiaq / Karoq','2016-on','5x112',57.1,30,45,17,21,9,700,'M14x1.5',VAG],
['SEAT','Ibiza / Arona','2017-on','5x100',57.1,35,48,15,18,7.5,500,'M14x1.5',VAG],
['SEAT','Leon','2012-on','5x112',57.1,38,50,16,20,8.5,560,'M14x1.5',VAG],
['SEAT','Ateca / Tarraco','2016-on','5x112',57.1,32,45,17,20,8.5,650,'M14x1.5',VAG],
['Cupra','Leon / Formentor','2020-on','5x112',57.1,32,50,18,20,8.5,600,'M14x1.5',VAG],
['Mercedes','A-Class / CLA / GLA','2012-on','5x112',66.6,38,52,16,20,8.5,580,'M14x1.5',MERC],
['Mercedes','C-Class (W205 / W206)','2014-on','5x112',66.6,35,52,17,20,9.5,650,'M14x1.5',MERC],
['Mercedes','E-Class / CLS','2016-on','5x112',66.6,30,48,17,20,9.5,700,'M14x1.5',MERC],
['Mercedes','S-Class','2013-on','5x112',66.6,25,45,18,21,9.5,800,'M14x1.5',MERC],
['Mercedes','GLC','2015-on','5x112',66.6,30,45,18,21,9.5,750,'M14x1.5',MERC],
['Mercedes','GLE / GLS','2015-on','5x112',66.6,25,45,19,22,10,900,'M14x1.5',MERC],
['Mercedes','Vito / V-Class','2014-on','5x112',66.6,40,55,17,20,8.5,900,'M14x1.5',MERC],
['BMW','1 / 2 Series (F20 / F22)','2011-2021','5x120',72.6,30,45,16,19,8.5,600,'M14x1.25',BMW],
['BMW','3 / 4 Series (F30 / F32)','2012-2019','5x120',72.6,30,45,17,20,9,650,'M14x1.25',BMW],
['BMW','3 / 4 Series (G20 / G22)','2019-on','5x112',66.5,25,45,17,20,9,650,'M14x1.25',BMW],
['BMW','5 Series (F10 / G30)','2010-on','5x120',72.6,25,45,17,20,9.5,700,'M14x1.25',BMW],
['BMW','X3 / X4 (G01 / G02)','2017-on','5x112',66.5,20,45,18,21,9.5,800,'M14x1.25',BMW],
['BMW','X5 / X6 (F15 / F16)','2013-2018','5x120',74.1,20,45,18,22,10,900,'M14x1.25',BMW],
['Mini','Mini (F55 / F56 / F57)','2014-on','5x112',66.6,40,54,15,19,8,500,'M14x1.25',BMW],
['Mini','Mini (R55 / R56 / R60)','2006-2015','4x100',56.1,35,48,15,18,7.5,470,'M12x1.5',BMW],
['Ford','Fiesta','2008-2023','4x108',63.4,35,50,15,18,7.5,450,'M12x1.5',FORD],
['Ford','Focus / ST','2011-on','5x108',63.4,45,55,16,19,8,550,'M12x1.5',FORD],
['Ford','Mondeo','2007-2022','5x108',63.4,45,55,16,19,8.5,600,'M12x1.5',FORD],
['Ford','Kuga','2012-on','5x108',63.4,45,52,17,20,8.5,650,'M12x1.5',FORD],
['Ford','Transit Custom','2012-on','5x160',65.1,40,60,16,20,8.5,925,'M14x1.5',FORD],
['Ford','Ranger','2012-2022','6x139.7',93.1,10,35,16,20,9,1000,'M12x1.5',FORD],
['Jaguar','XE / XF / XJ','2010-on','5x108',63.4,38,50,17,20,9,650,'M14x1.5',JLR],
['Jaguar','F-Pace / E-Pace','2016-on','5x108',63.4,35,49,18,22,9.5,750,'M14x1.5',JLR],
['Range Rover','Evoque / Velar / Disco Sport','2015-on','5x108',63.4,35,49,18,22,9.5,750,'M14x1.5',JLR],
['Range Rover','Range Rover / Sport','2013-2022','5x120',72.6,38,50,19,23,10,900,'M14x1.5',JLR],
['Land Rover','Defender (L663) / Discovery 5','2017-on','5x120',72.6,38,52,18,22,9.5,950,'M14x1.5',JLR],
['Porsche','Macan','2014-2024','5x112',66.5,18,30,18,22,10,750,'M14x1.5',['Porsche']],
['Porsche','Cayenne','2010-on','5x130',71.6,45,60,18,22,10.5,900,'M14x1.5',['Porsche']],
['Porsche','Panamera','2009-on','5x130',71.6,40,60,18,22,10.5,800,'M14x1.5',['Porsche']],
['Porsche','911 (997 / 991 / 992)','2004-on','5x130',71.6,40,60,18,21,11,700,'M14x1.5',['Porsche']],
['Tesla','Model 3','2017-on','5x114.3',64.1,35,45,18,20,9,650,'M14x1.5',['Tesla']],
['Tesla','Model Y','2020-on','5x114.3',64.1,35,45,19,21,9.5,750,'M14x1.5',['Tesla']],
['Tesla','Model S / Model X','2012-on','5x120',64.1,35,45,19,22,10,850,'M14x1.5',['Tesla']],
['Volvo','XC40 / V40','2012-on','5x108',63.4,35,50,17,20,9,700,'M14x1.5',['Volvo']],
['Volvo','XC60 / XC90 / V60 / S60','2015-on','5x108',63.4,35,45,18,22,9.5,850,'M14x1.5',['Volvo']],
['Lexus','IS / NX / RX','2013-on','5x114.3',60.1,30,45,17,21,9,700,'M14x1.5',TOY],
['Toyota','Corolla / Auris','2013-on','5x114.3',60.1,35,50,16,19,8,600,'M12x1.5',TOY],
['Toyota','RAV4 / C-HR','2016-on','5x114.3',60.1,35,50,17,20,8.5,700,'M12x1.5',TOY],
['Toyota','Yaris','2011-on','4x100',54.1,35,45,15,17,7,450,'M12x1.5',TOY],
['Toyota','Hilux','2015-on','6x139.7',106,10,35,16,20,9,1000,'M12x1.5',TOY],
['Nissan','Qashqai','2013-on','5x114.3',66.1,35,45,17,20,8.5,690,'M12x1.25',REN],
['Nissan','Juke','2010-on','5x114.3',66.1,35,45,16,19,8,600,'M12x1.25',REN],
['Nissan','X-Trail','2013-on','5x114.3',66.1,35,45,17,20,8.5,750,'M12x1.25',REN],
['Renault','Clio / Captur','2012-on','4x100',60.1,35,45,15,18,7.5,500,'M12x1.5',REN],
['Renault','Megane','2015-on','5x114.3',66.1,35,48,16,19,8.5,600,'M12x1.5',REN],
['Dacia','Duster','2017-on','5x114.3',66.1,35,48,16,19,8,700,'M12x1.5',REN],
['Dacia','Sandero','2012-on','4x100',60.1,35,45,15,17,7,500,'M12x1.5',REN],
['Vauxhall','Corsa (F)','2019-on','4x108',65.1,20,40,15,18,7.5,500,'M12x1.25',PSA],
['Vauxhall','Astra (K)','2015-2021','5x105',56.6,35,45,16,19,8,600,'M12x1.5',PSA],
['Vauxhall','Astra (L)','2021-on','5x108',65.1,20,40,16,19,8,600,'M12x1.25',PSA],
['Vauxhall','Insignia','2017-on','5x120',67.1,30,45,17,20,8.5,700,'M12x1.5',PSA],
['Peugeot','208','2012-on','4x108',65.1,20,40,15,18,7.5,500,'M12x1.25',PSA],
['Peugeot','308','2013-on','4x108',65.1,20,40,16,19,8,550,'M12x1.25',PSA],
['Peugeot','3008 / 5008','2016-on','5x108',65.1,20,40,17,20,8.5,700,'M12x1.25',PSA],
['Citroen','C3 / DS3','2010-on','4x108',65.1,20,40,15,18,7.5,500,'M12x1.25',PSA],
['Citroen','C4 / C5 Aircross','2010-on','4x108',65.1,20,40,16,19,8,600,'M12x1.25',PSA],
['Kia','Ceed / Proceed','2012-on','5x114.3',67.1,35,50,16,19,8,600,'M12x1.5',HYU],
['Kia','Sportage / Niro','2015-on','5x114.3',67.1,30,50,17,20,8.5,700,'M12x1.5',HYU],
['Hyundai','i30','2012-on','5x114.3',67.1,35,50,16,19,8,600,'M12x1.5',HYU],
['Hyundai','Tucson / Santa Fe','2015-on','5x114.3',67.1,30,50,17,20,8.5,750,'M12x1.5',HYU],
['Honda','Civic','2012-on','5x114.3',64.1,35,50,16,20,8.5,600,'M12x1.5',['Honda']],
['Honda','CR-V','2012-on','5x114.3',64.1,35,50,17,20,8.5,700,'M12x1.5',['Honda']],
['Mazda','Mazda3 / Mazda6','2013-on','5x114.3',67.1,35,50,16,19,8.5,600,'M12x1.5',['Mazda']],
['Mazda','CX-5 / CX-30','2015-on','5x114.3',67.1,35,50,17,20,8.5,700,'M12x1.5',['Mazda']],
['Alfa Romeo','Giulia / Stelvio','2016-on','5x110',65.1,30,45,17,21,9,700,'M14x1.5',['Alfa Romeo']],
['Fiat','500 / 500X','2007-on','4x98',58.1,30,42,15,17,7,450,'M12x1.25',['Fiat']],
['Suzuki','Swift','2010-on','4x100',60.1,35,45,15,17,7,450,'M12x1.25',['Suzuki']],
['Suzuki','Vitara / S-Cross','2015-on','5x114.3',60.1,35,50,16,19,8,650,'M12x1.25',['Suzuki']]
];

  var V = ROWS.map(function (r) {
    return { make:r[0], model:r[1], years:r[2], pcd:r[3], bore:r[4], et:[r[5],r[6]],
             dia:[r[7],r[8]], width:r[9], load:r[10], thread:r[11], family:r[12], note:r[13] || '' };
  });

  var MAKE_TAGS = ['Audi','Volkswagen','VW','Skoda','SEAT','Cupra','Mercedes','Ford','Jaguar',
                   'Range Rover','Land Rover','Porsche','Tesla','Volvo','Lexus','BMW','Mini','Toyota',
                   'Nissan','Renault','Dacia','Vauxhall','Opel','Peugeot','Citroen','Kia','Hyundai',
                   'Honda','Mazda','Alfa Romeo','Fiat','Suzuki','Ferrari','Transporter'];

  var BRAND_TAGS = ['Premium Brands','Japan Racing','Concaver','Rotiform','BOLA','79Wheels','Seventy9','Calibre','Rota','DRC','Carbonado','Magline','Dotz','Riviera','Yanar','Stuttgart'];

  // Only these are real bolt patterns. Stops a mangled tag like "5x114"
  // (from a "5x114,3" title) being read as a valid PCD.
  var PCDS = ['4x98','4x100','4x108','4x114.3','5x98','5x100','5x105','5x108','5x110','5x112','5x114.3','5x120','5x127','5x130','5x139.7','5x150','5x160','6x114.3','6x120','6x130','6x139.7'];

  function num(v){ var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; }
  function normPcd(v){
    var m = String(v || '').toLowerCase().replace(/\s/g, '').replace(',', '.').match(/^(\d)x(\d{2,3}(?:\.\d+)?)$/);
    if (!m) return null;
    var p = m[1] + 'x' + parseFloat(m[2]);
    return PCDS.indexOf(p) > -1 ? p : null;
  }

  function parseWheel(tags, extra){
    var w = { pcd:null, bore:null, et:null, dia:null, width:null, load:null, makes:[], brand:false };
    extra = extra || {};
    if (extra.brand) w.brand = true;
    if (extra.pcd) w.pcd = normPcd(extra.pcd);
    if (extra.bore) w.bore = num(extra.bore);
    if (extra.et !== undefined && extra.et !== null && extra.et !== '') w.et = num(extra.et);
    if (extra.load) w.load = num(String(extra.load).replace(/[^0-9.]/g, ''));
    if (typeof tags === 'string') tags = tags.split(',');
    (tags || []).forEach(function (raw){
      var t = String(raw).trim(), l = t.toLowerCase(), m;
      if (BRAND_TAGS.indexOf(t) > -1) w.brand = true;
      if (MAKE_TAGS.indexOf(t) > -1) { w.makes.push(t); return; }
      if (!w.pcd && (m = l.match(/^(\d)x(\d{2,3}(?:\.\d+)?)$/)) && parseFloat(m[2]) >= 98) w.pcd = normPcd(l);
      else if ((m = l.match(/^(1[3-9]|2[0-4])x(\d{1,2}(?:\.\d+)?)$/))) { if (w.dia === null) w.dia = num(m[1]); if (w.width === null) w.width = num(m[2]); }
      else if (w.et === null && (m = l.match(/^et\s?(-?\d+(?:\.\d+)?)$/))) w.et = num(m[1]);
      else if (w.bore === null && (m = l.match(/^(\d{2,3}(?:\.\d+)?)\s?(?:mm)?\s?bore$/))) w.bore = num(m[1]);
      else if (w.load === null && (m = l.match(/^(\d{3,4})\s?kg$/))) w.load = num(m[1]);
    });
    // Brand wheels often carry their specs in the title rather than in tags
    var txt = String(extra.title || '');
    var m2;
    if (!w.pcd && (m2 = txt.match(/(\d)\s?x\s?(\d{3}(?:[.,]\d)?)/))) w.pcd = normPcd(m2[1] + 'x' + m2[2].replace(',', '.'));
    if (w.et === null && (m2 = txt.match(/\bET\s?(-?\d{1,2})\b/i))) w.et = num(m2[1]);
    if (w.bore === null && (m2 = txt.match(/\b(?:CB|bore)\s?:?\s?(\d{2,3}(?:\.\d+)?)/i))) w.bore = num(m2[1]);
    if (w.dia === null && (m2 = txt.match(/\b(1[3-9]|2[0-4])\s?x\s?(\d{1,2}(?:\.\d+)?)\b/))) { w.dia = num(m2[1]); if (w.width === null) w.width = num(m2[2]); }
    return w;
  }

  function familyOk(w, v){
    if (!w.makes.length) return true;
    for (var i = 0; i < w.makes.length; i++) if (v.family.indexOf(w.makes[i]) > -1) return true;
    return false;
  }

  function check(w, v){
    var rows = [], rings = false;
    function add(k, s, t){ rows.push({ key:k, status:s, text:t }); }
    if (!familyOk(w, v)) add('Made for', 'warn', 'This wheel is badged for ' + w.makes.join(' / ') + '. The specs fit your ' + v.make + ', but check bolts and seats with us first.');
    if (!w.pcd) add('Bolt pattern', 'unknown', 'Not listed on this wheel.');
    else if (w.pcd !== normPcd(v.pcd)) add('Bolt pattern', 'fail', 'Wheel is ' + w.pcd + ', your car needs ' + v.pcd + '.');
    else add('Bolt pattern', 'ok', w.pcd + ' matches.');
    if (w.bore === null) add('Centre bore', 'unknown', 'Not listed on this wheel. We will confirm it and supply spigot rings if needed.');
    else if (w.bore < v.bore - 0.05) add('Centre bore', 'fail', 'Wheel bore is ' + w.bore + 'mm, smaller than your ' + v.bore + 'mm hub. It will not go on.');
    else if (w.bore > v.bore + 0.15) { rings = true; add('Centre bore', 'ok', 'Fits with ' + w.bore + ' to ' + v.bore + 'mm spigot rings.'); }
    else add('Centre bore', 'ok', w.bore + 'mm, hub centric.');
    if (w.et === null) add('Offset', 'unknown', 'Not listed on this wheel.');
    else if (w.et >= v.et[0] && w.et <= v.et[1]) add('Offset', 'ok', 'ET' + w.et + ' suits this car (ET' + v.et[0] + ' to ET' + v.et[1] + ').');
    else if (w.brand) add('Offset', 'warn', 'ET' + w.et + ' is outside the standard ET' + v.et[0] + ' to ET' + v.et[1] + ' range. Aggressive fitment, message us before ordering.');
    else if (w.et < v.et[0]) add('Offset', 'fail', 'ET' + w.et + ' is too low for this car. The wheel would stick out of the arch.');
    else add('Offset', 'fail', 'ET' + w.et + ' is too high for this car. The wheel would sit too far in.');
    if (w.dia === null) add('Size', 'unknown', 'Not listed on this wheel.');
    else if (w.dia < v.dia[0]) add('Size', 'fail', w.dia + ' inch is too small to clear the brakes. Minimum is ' + v.dia[0] + ' inch.');
    else if (w.dia > v.dia[1]) add('Size', w.brand ? 'warn' : 'fail', w.dia + ' inch is bigger than standard for this car (up to ' + v.dia[1] + ' inch).');
    else if (w.width !== null && w.width > v.width) add('Size', w.brand ? 'warn' : 'fail', w.dia + 'x' + w.width + ' is wider than standard (max ' + v.width + ' inch). May need arch work.');
    else add('Size', 'ok', w.dia + (w.width ? 'x' + w.width : ' inch') + ' suits this car.');
    if (w.load === null && v.load >= 850) add('Load rating', 'warn', 'Not listed. This vehicle needs ' + v.load + 'kg per wheel, so message us to confirm before ordering.');
    else if (w.load === null) add('Load rating', 'unknown', 'We will confirm the load rating for your car.');
    else if (w.load < v.load) add('Load rating', 'fail', w.load + 'kg per wheel is below the ' + v.load + 'kg this car needs.');
    else add('Load rating', 'ok', w.load + 'kg per wheel, enough for this car.');
    var rank = { ok:0, unknown:1, warn:2, fail:3 }, worst = 'ok';
    rows.forEach(function (r){ if (rank[r.status] > rank[worst]) worst = r.status; });
    return { overall:worst, rows:rows, rings:rings };
  }

  function fits(w, v){
    // Bolt pattern must match exactly. Everything else is judged on the
    // numbers, whatever make or brand the wheel is badged as.
    if (!w.pcd || w.pcd !== normPcd(v.pcd)) return false;
    // A wheel bore smaller than the hub physically cannot go on.
    if (w.bore !== null && w.bore < v.bore - 0.05) return false;
    if (w.brand){
      if (w.et !== null && (w.et < v.et[0] - 10 || w.et > v.et[1] + 10)) return false;
      if (w.dia !== null && (w.dia < v.dia[0] || w.dia > v.dia[1] + 1)) return false;
      if (w.width !== null && w.width > v.width + 1.5) return false;
    } else {
      if (w.bore === null) return false;
      if (w.et === null || w.et < v.et[0] || w.et > v.et[1]) return false;
      if (w.dia === null || w.dia < v.dia[0] || w.dia > v.dia[1]) return false;
      if (w.width !== null && w.width > v.width) return false;
    }
    if (w.load !== null && w.load < v.load) return false;
    return true;
  }

  /* Warnings shown on a wheel card so the customer knows what to check */
  function flags(w, v){
    var f = [];
    if (!familyOk(w, v)) f.push('Made for ' + w.makes.join(' / ') + ' \u2014 check bolts with us');
    if (!w.brand) return f;
    if (w.bore === null) f.push('Bore to confirm');
    else if (w.bore > v.bore + 0.15) f.push('Needs ' + w.bore + '\u2013' + v.bore + ' spigot rings');
    if (w.et === null) f.push('Offset to confirm');
    else if (w.et < v.et[0] || w.et > v.et[1]) f.push('Aggressive fitment \u2014 check with us');
    if (w.width !== null && w.width > v.width) f.push('Wide fitment \u2014 may need arch work');
    return f;
  }

  var api = { vehicles:V, parseWheel:parseWheel, check:check, fits:fits, flags:flags };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.OMIFit = api;
})(typeof window !== 'undefined' ? window : this);
